import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import SEO from '../components/SEO';

function ProductCard() {
  const { t } = useLanguage();
  return (
    <div className="product-info">
      <h1 className="product-title">{t('home-title')}</h1>
      <p className="product-subtitle">{t('home-subtitle')}</p>
      <ul className="features">
        <li>{t('home-feat-1')}</li>
        <li>{t('home-feat-2')}</li>
        <li>{t('home-feat-3')}</li>
      </ul>
      <div className="cta-group">
        <Link to="/contact" className="cta-button">{t('btn-quote')}</Link>
        <Link to="/gallery" className="secondary-button">{t('btn-gallery')}</Link>
      </div>
    </div>
  );
}

export default function Home() {
  const { t } = useLanguage();
  return (
    <>
      <SEO title={t('seo-home-title')} description={t('seo-home-desc')} />
      {/* Desktop: card floats over model bottom-left via CSS */}
      <div className="home-desktop-card">
        <ProductCard />
      </div>
      {/* Mobile: card below the model in normal flow */}
      <div className="home-mobile-card">
        <ProductCard />
      </div>
    </>
  );
}
